import ExcelJS from "exceljs";
import saveAs from "file-saver";

export type ExcelColumn<T> = {
  header: string;
  key: keyof T | string;
  width?: number;
  format?: (row: T) => string | number;
};

export async function exportRowsToExcel<T extends object>(
  fileName: string,
  sheetName: string,
  columns: ExcelColumn<T>[],
  rows: T[]
): Promise<void> {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);

  worksheet.columns = columns.map((col) => ({
    key: String(col.key),
    width: col.width ?? 20,
  }));

  worksheet.addRow(columns.map((col) => col.header));

  rows.forEach((row) => {
    worksheet.addRow(
      columns.map((col) => {
        if (col.format) return col.format(row);
        return row[col.key as keyof T] ?? "";
      })
    );
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), fileName);
}
